// import axios from "axios";
// import env from "../config";
import axios from "../api/axios";
import store from "../store";
import { buildQuery } from "./telematicsRequest";
// const client = axios.create({
//   baseURL: env.API_ENDPOINT,
//   // baseURL: `http://35.236.93.48/api/Client`,
//   json: true
// });

export default {
  async execute(method, resource, data) {
    return axios
      .telematicsEndPoint({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
      })
      .then((req) => {
        return req.data;
      });
  },
  async executeFiles(method, resource, data) {
    return axios
      .telematicsEndPoint({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
        responseType: "blob",
      })
      .then((req) => {
        return req.data;
      });
  },
  // Equipments Page related API's Start
  // ,selectedGroup
  // &assetType=${selectedAsset}&brand=${selectedBrand}&model=${selectedModel}
  // ,selectedAsset,selectedBrand,selectedModel
  getMapEquipmentsList(
    ownerType,
    searchKey,
    contractId,
    searchStoreId,
    selectedAsset,
    selectedBrand,
    selectedModel,
    selectedZone,
    selectedGroup,
    selectedAlert,
    selectedGPSReading,
    selectedLocation,
    selectedRentalStatus,
    searchFieldAddress,
    lowDef,
    lowFuel,
    lowVoltage
  ) {
    // &equipmentStatus=${equipmentStatus}

    let paramstr = `/Equipments/active?ownerType=${ownerType}`;
    if (searchKey) {
      paramstr = paramstr.concat(`&searchKey=${searchKey}`);
    }
    if (contractId) {
      paramstr = paramstr.concat(`&contractId=${contractId}`);
    }
    if (searchStoreId) {
      paramstr = paramstr.concat(`&depotId=${searchStoreId}`);
    }
    if (selectedAsset) {
      paramstr = paramstr.concat(`&assetType=${selectedAsset}`);
      console.log(paramstr);
    }
    if (selectedBrand) {
      paramstr = paramstr.concat(`&brand=${selectedBrand}`);
    }
    if (selectedModel) {
      paramstr = paramstr.concat(`&model=${selectedModel}`);
    }
    if (selectedZone) {
      paramstr = paramstr.concat(`&geofenceId=${selectedZone}`);
    }
    if (selectedGroup) {
      paramstr = paramstr.concat(`&group=${selectedGroup}`);
    }
    // if(selectedType){
    //   paramstr= paramstr.concat(`&type=${selectedType}`);
    // }
    if (selectedAlert) {
      paramstr = paramstr.concat(`&alert=${selectedAlert}`);
    }
    if (selectedGPSReading) {
      paramstr = paramstr.concat(`&lastGPSReading=${selectedGPSReading}`);
    }
    if (selectedLocation) {
      paramstr = paramstr.concat(`&location=${selectedLocation}`);
    }
    if (selectedRentalStatus) {
      paramstr = paramstr.concat(`&rentalStatus=${selectedRentalStatus}`);
    }
    // filter of search is handled from UI side
    if (searchFieldAddress) {
      paramstr = paramstr.concat(`&address=${searchFieldAddress}`);
    }
    if (lowDef) {
      paramstr = paramstr.concat(`&lowDef=${lowDef}`);
    }
    if (lowFuel) {
      paramstr = paramstr.concat(`&lowFuel=${lowFuel}`);
    }
    if (lowVoltage) {
      paramstr = paramstr.concat(`&lowVoltage=${lowVoltage}`);
    }
    // if(critical){
    //   paramstr= paramstr.concat(`&alert=${critical}`);
    // }if(low){
    //   paramstr= paramstr.concat(`&alert=${low}`);
    // }if(good){
    //   paramstr= paramstr.concat(`&alert=${good}`);
    // }
    return this.execute("get", paramstr);
  },
  getEquipmentsList(
    fromDate,
    toDate,
    equipmentSearch,
    status,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Equipments/rental?fromDate=${fromDate}&toDate=${toDate}&searchkey=${equipmentSearch}&contractstatus=${status}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getcustomerDataList(
    cId,
    fromDate,
    toDate,
    equipmentSearch,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Equipments/customer?customerId=${cId}&fromDate=${fromDate}&toDate=${toDate}&searchkey=${equipmentSearch}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getBirchEquipmentList(
    cId,
    fromDate,
    toDate,
    equipmentSearch,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder
  ) {
    return this.execute(
      "get",
      `/Equipments/birch?customerId=${cId}&fromDate=${fromDate}&toDate=${toDate}&searchkey=${equipmentSearch}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
  },
  getCustomerOwnedEqupmentDetailsById(id, equipId) {
    return this.execute(
      "get",
      `/Equipments/customer/${id}?equipmentId=${equipId}`
    );

    // return this.execute("get", `/Equipments/customer/${id}`);
  },
  getCustomerOwnedEqupmentDetailsByIdNew(assetid) {
    return this.execute("get", `/Equipments/customer/assetId/${assetid}`);

    // return this.execute("get", `/Equipments/customer/${id}`);
  },
  getBirchDetailsById(id, equipId) {
    return this.execute(
      "get",
      `/Equipments/customer/${id}?equipmentId=${equipId}`
    );
  },
  // *-------Update Access Control Code API's Start---------*
  unAssignAccessControlCode(payload) {
    return this.execute("put", `/Equipments/accesscode/unassign`, payload);
  },
  getAccessKeysList(customerId, ownerType) {
    return this.execute(
      "get",
      `/Equipments/accesscodes?customerId=${customerId}&ownerType=${ownerType}`
    );
  },
  updateAndAssignNewCode(payload) {
    return this.execute("put", `/Equipments/accesscode/assign`, payload);
  },
  createAndAssignNewCode(payload) {
    return this.execute(
      "post",
      `/Equipments/accesscode/create-assign`,
      payload
    );
  },
  // List View of Access Codes
  getBirchAccessCodesList() {
    return this.execute("get", `/Equipments/accesscodes/birch`);
  },
  getCustomerAccessCodesList(customerId) {
    return this.execute(
      "get",
      `/Equipments/accesscodes/customer?customerId=${customerId}`
    );
  },
  updateAccessControlCodeDetails(id, customerId, ownerType, payload) {
    // id is extendedInfoId
    return this.execute(
      "put",
      `/Equipments/accesscode/${id}?customerId=${customerId}&ownerType=${ownerType}`,
      payload
    );
  },
  createAccessControlCode(payload) {
    return this.execute("post", `/Equipments/accesscode/create`, payload);
  },
  readEventDetailsById(assetId, criticality) {
    return this.execute(
      "get",
      `/Equipments/events/${assetId}?criticality=${criticality}`
    );
  },
  // *-------Update Access Control Code API's End---------*
  // Reports Page related API's Start
  getUtilizationReportList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    utilizationTargetType,
    utilizationTargetValue,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/report/utilization?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&utilizationTargetType=${utilizationTargetType}&utilizationTargetValue=${utilizationTargetValue}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  //Utilization report excel export
  getutilizationReportExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    utilizationTargetType,
    utilizationTargetValue,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/utilization/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&utilizationTargetType=${utilizationTargetType}&utilizationTargetValue=${utilizationTargetValue}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getNewOperationalReportList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/report/operational?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getNewOperationalReportListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/operational/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getNewOperationalReportListExportPDF(payload) {
    return this.executeFiles("post", `/report/operational/pdf`, payload);
  },
  getGroups() {
    return this.execute("get", "group");
  },
  updateEquipmentImage(payload) {
    return this.execute("put", `/Equipments/image`, payload);
  },
  deleteCustomerEquipmentImage(Id) {
    return this.execute("delete", `/Equipments/image/${Id}`);
  },
  getMachinesAlarms(custid, searchKey = "", units = "") {
    return this.execute(
      "get",
      `/Equipments/onrent-onreservation?customerId=${custid}&searchKey=${searchKey}&units=${units}`
    );
  },
  getMachinesAlarmsEquipment(id) {
    return this.execute("get", `/Alarm/alarmswithequipment/${id}`);
  },
  getAlarmContacts(custid) {
    return this.execute("get", `/Geofence/contacts?customerId=${custid}`);
  },
  CreateAlarmContacts(custid, payload) {
    return this.execute(
      "post",
      `/Geofence/contact?customerId=${custid}`,
      payload
    );
  },
  CreateAlarm(payload) {
    return this.execute("post", `/Geofence/alarm`, payload);
  },
  UpdateAlarm(id, payload) {
    return this.execute("put", `/Geofence/alarm/${id}`, payload);
  },
  getAlarmsList(zoneId) {
    return this.execute("get", `/Geofence/alarms/zoneId?zoneId=${zoneId}`);
  },
  deleteAlarm(id) {
    return this.execute("delete", `/Geofence/alarms/id?id=${id}`);
  },
  updateAlarmEnabled(id, payload) {
    return this.execute(
      "put",
      `Geofence/alarm/${id}/disable-or-enable`,
      payload
    );
  },
  getgroupById(id) {
    return this.execute("get", `group/${id}`);
  },
  creategroup(payload) {
    return this.execute("post", `/group`, payload);
  },
  updategroup(id, payload) {
    return this.execute("put", `/group/${id}`, payload);
  },
  getMachines(id) {
    let custId = id == null ? "" : id;
    return this.execute("get", `group/machines?customerId=${custId}`);
  },
  getTelematicMachines(searchKey) {
    return this.execute(
      "get",
      `Group/telematicmachines/search?searchKey=${searchKey}`
    );
  },
  getTelematicMachinesnew(searchKey) {
    return this.execute("get", `Group/equipment/search?searchKey=${searchKey}`);
  },
  getTelematicMachinesnewrent(searchKey) {
    // https://birch-gw.incus5.com/telematics/v1.0/Group/telematicrentmachines/search?searchKey=
    return this.execute(
      "get",
      `Group/telematicrentmachines/search?searchKey=${searchKey}`
    );
  },
  getSearchMachines(id, searchkey) {
    let custId = id == null ? "" : id;
    let searchVal = searchkey ? searchkey : "";
    return this.execute(
      "get",
      `Group/machines/search?customerId=${custId}&searchkey=${searchVal}`
    );
  },
  // Contracts Page related API's Start
  getContractsList(
    fromDate,
    toDate,
    contractSearch,
    status,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder
  ) {
    return this.execute(
      "get",
      `/Contracts?fromDate=${fromDate}&toDate=${toDate}&searchkey=${contractSearch}&status=${status}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
  },
  getcontractsDataById(id) {
    return this.execute("get", `/Contracts/${id}`);
  },
  getJobsitesId(id) {
    return this.execute("get", `/Contracts/jobsites?customerId=${id}`);
  },
  getCustomersList(pageNumber, pageSize, searchKey) {
    return this.execute(
      "get",
      `Customers?pageNumber=${pageNumber}&pageSize=${pageSize}&searchKey=${searchKey}`
    );
  },

  getCustomerListById(id) {
    return this.execute("get", `Customers/${id}`);
  },
  getStats() {
    return this.execute("get", `/Equipments/stats`);
  },
  getBrands() {
    return this.execute("get", `/Equipments/brands`);
  },
  getModels() {
    return this.execute("get", `/Equipments/models`);
  },
  getLocations() {
    return this.execute("get", `/Contracts/locations`);
  },
  getTrackModels() {
    return this.execute("get", `/Trackunit/models`);
  },
  getSearchTrackModels(searchkey) {
    return this.execute("get", `/Trackunit/models/${searchkey}`);
  },
  getTrackBrands() {
    return this.execute("get", `/Trackunit/brands`);
  },
  getSearchTrackBrands(searchkey) {
    return this.execute("get", `/Trackunit/brands/${searchkey}`);
  },
  getTrackCategories() {
    return this.execute("get", `/Trackunit/categories`);
  },
  getSearchTrackCategories(searchkey) {
    return this.execute("get", `/Trackunit/categories/${searchkey}`);
  },
  getBasicCustomers() {
    return this.execute("get", `Customers/basic`);
  },
  searchBasicCustomers(searchKey) {
    return this.execute("get", `Customers/search?searchText=${searchKey}`);
  },
  updateReloadCustomers() {
    return this.execute("get", `Customers/basic/reload`);
  },
  updateSpecification(machineid, payload) {
    return this.execute("put", `/Trackunit/machine/${machineid}`, payload);
  },
  getSpecifications(unitId) {
    return this.execute("get", `/Equipments/specification/${unitId}`);
    // https://maxx-gw.birchequipment.com/telematics/v1.0/Equipments/specification/{assetId}
  },
  getSpecificationsNew(assetId) {
    return this.execute("get", `/Equipments/specification/assetId/${assetId}`);
  },
  removeGroup(id) {
    return this.execute("delete", `/group/${id}`);
  },
  getproductexclusions() {
    return this.execute("get", `Settings/productexclusions`);
  },
  addproductexclusions(payload) {
    return this.execute("post", `Settings/productexclusions`, payload);
  },
  deleteproductexclusions(id) {
    return this.execute("delete", `Settings/${id}`);
  },
  //*On Rent Report List & export
  getOnReportList(
    ownerType,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/rent?ownerType=${ownerType}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getOnReportListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/rent/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&contractId=${contractId}&model=${model}&searchKey=${searchField}`
    );
  },
  //*On Reservation List & Export
  getOnReservationList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/rent-reservation?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&contractId=${contractId}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getOnReservationListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/rent-reservation/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&contractId=${contractId}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}`
    );
  },
  //*Overdue Report List & Export
  getOnOverdueList(
    ownerType,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/rent-overdue?ownerType=${ownerType}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&contractId=${contractId}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getOnOverdueListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/rent-overdue/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&contractId=${contractId}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}`
    );
  },
  //*scheduled for pickups report List & Export
  getSchedledPickupsList(
    fromDate,
    toDate,
    pageNumber,
    pageSize,
    model,
    jobSite,
    zone
  ) {
    return this.execute(
      "get",
      `/Report/rent-scheduled-pickup?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&pageSize=${pageSize}&model=${model}&jobSite=${jobSite}&zone=${zone}`
    );
  },
  getSchedledPickupsListExport(fromDate, toDate) {
    return this.executeFiles(
      "get",
      `/Report/rent-scheduled-pickup/export?fromDate=${fromDate}&toDate=${toDate}`
    );
  },
  //*Existing Active Alerts Report & Export
  getActiveAlertsList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accessControlCodes,
    model,
    searchField,
    // contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/activealerts?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accessControlCodes}&model=${model}&searchKey=${searchField}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getActiveAlertsListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accessControlCodes,
    model,
    searchField
    // contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/activealerts/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accessControlCodes}&model=${model}&searchKey=${searchField}`
    );
  },
  //*Trip Report List & Export
  getTripReportList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/trips?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getTripReportListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/trips/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  //*Incident Report List & Export
  getIncidentReportList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/incident?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getIncidentReportListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/report/incident/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  //*Activity Report List & Export
  getActivityList(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize
  ) {
    return this.execute(
      "get",
      `/Report/activity?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getActivityListExport(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/activity/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  //*New Utilization Report List & export
  getNewUtilizationReportList(
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    model,
    searchField,
    contractId,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder,
    ownerType
  ) {
    return this.execute(
      "get",
      `/Report/newutilization?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&model=${model}&searchKey=${searchField}&contractId=${contractId}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
  },
  getNewUtilizationListExport(
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    model,
    searchField,
    contractId,
    sortBy,
    sortOrder,
    ownerType
  ) {
    return this.executeFiles(
      "get",
      `/Report/newutilization/export?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&model=${model}&searchKey=${searchField}&contractId=${contractId}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
  },
  // *-------- GeoFences
  getGeofences() {
    return this.execute("get", `Alert/site`);
  },
  createGeofence(payload) {
    return this.execute("post", `Alert/site`, payload);
  },
  getGeofenceById(id) {
    return this.execute("get", `Alert/site/${id}`);
  },
  updateGeofence(id, payload) {
    return this.execute("put", `Alert/site/${id}`, payload);
  },
  deleteGeofence(id) {
    return this.execute("delete", `Alert/site/${id}`);
  },
  getJobSites() {
    return this.execute("get", `/Report/locations`);
  },
  getZones() {
    // return this.execute("get", `Geofence`);
    return this.execute("get", `Alert/site`);
  },
  // Service Module (1) Service Template
  createServiceTemplate(payload) {
    return this.execute("post", `/ServiceTemplate`, payload);
  },
  getServiceTemplateList() {
    return this.execute("get", `/ServiceTemplate`);
  },
  getServiceTemplateById(id) {
    return this.execute("get", `/ServiceTemplate/${id}`);
  },
  removeServiceTemplate(id) {
    return this.execute("delete", `/ServiceTemplate/${id}`);
  },
  updateServiceTemplate(id, payload) {
    return this.execute("put", `/ServiceTemplate/${id}`, payload);
  },
  //(2) Service Maintenance
  getServiceEquipments(category, customer, searchKey) {
    return this.execute(
      "get",
      `/ServiceTemplate/equipments?category=${category}&customer=${customer}&searchKey=${searchKey}`
    );
  },
  linkServiceTemplateWithAsset(payload) {
    return this.execute("post", `/ServiceTemplate/assetmapping`, payload);
  },
  //(3) Service Report
  getserviceModuleCategories() {
    return this.execute("GET", `/ServiceTemplate/categories`);
  },
  getServiceRecords(pageNumber, pageSize) {
    return this.execute(
      "GET",
      `/ServiceTemplate/servicerecords?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  getWorkOrders() {
    return this.execute("GET", `/ServiceTemplate/workorders`);
  },
  getSearchWorkOrders(searchText) {
    return this.execute("GET", `/ServiceTemplate/workorders/${searchText}`);
  },
  getWorkOrderInformation(equipmentID) {
    return this.execute("GET", `/ServiceTemplate/asset/${equipmentID}`);
  },
  submitWorkOrderInfo(payload) {
    return this.execute("post", `/ServiceTemplate/mapservice`, payload);
  },
  getCompletedServiceRecords(fromDate, toDate, searchKey) {
    return this.execute(
      "get",
      `/ServiceTemplate/closedservices?fromDate=${fromDate}&toDate=${toDate}&searchKey=${searchKey}`
    );
  },
  deleteCompletedService(serviceLinkRecordId) {
    return this.execute(
      "put",
      `/ServiceTemplate/deletecompletedservice/${serviceLinkRecordId}`
    );
  },
  getScheduledServices(templateId) {
    return this.execute(
      "get",
      `/ServiceTemplate/scheduledservices?templateId=${templateId}`
    );
  },
  unlinkServiceRecord(templateId, equipmentId) {
    return this.execute(
      "put",
      `/ServiceTemplate/assetunlink?templateId=${templateId}&equipmentId=${equipmentId}`
    );
  },
  getMaintenanceList(equipmentId) {
    return this.execute("get", `/ServiceTemplate/services/${equipmentId}`);
  },
  getMaintenanceListNew(assetId) {
    return this.execute("get", `/ServiceTemplate/services/assetId/${assetId}`);
  },
  getWorkOrderIdData(workOrderId) {
    return this.execute("get", `/ServiceTemplate/workorder/${workOrderId}`);
  },
  // App Notifications
  getNotifications(userId) {
    return this.execute("get", `/Notification/AllNotifications/${userId}`);
  },
  updateNotification(notifyId) {
    return this.execute("put", `/Notification/Notification/${notifyId}`);
  },
  markAllAsViewed(userId) {
    return this.execute("put", `/Notification/ClearAllNotifications/${userId}`);
  },
  // Active Contracts List
  getActiveContractsWithTelemactics(pageNumber, pageSize) {
    return this.execute(
      "get",
      `/Contracts/telematics?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  linkSMSCustomer(payload) {
    return this.execute("put", `/Customers/smscustomer`, payload);
  },
  // All reports PDF
  getUtilizationReportListPDF(
    fromDate,
    toDate,
    machineIds,
    utilizationTargetType,
    utilizationTargetValue,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model
  ) {
    return this.executeFiles(
      "get",
      `/Report/utilization/pdf?fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&utilizationTargetType=${utilizationTargetType}&utilizationTargetValue=${utilizationTargetValue}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}`
    );
  },
  getUtilizationPDF(payload) {
    return this.executeFiles("post", `/Report/utilization/pdf`, payload);
  },
  getExistingActiveAlertsReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accessControlCodes,
    model,
    searchField
    // contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/activeAlerts/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&model=${model}&accessCodes=${accessControlCodes}&searchKey=${searchField}`
    );
  },
  getOnRentReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/rent/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&contractId=${contractId}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}`
    );
  },
  getOnReservationReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/onreservation/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getOverdueListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/overdue/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getNewOperationalReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/operational/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getTripReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/trips/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getIncidentReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/incident/pdf?fromDate=${fromDate}&ownerType=${ownerType}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&accessCodes=${accesscontrolcode}&model=${model}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getActivityReportListPDF(
    ownerType,
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    accesscontrolcode,
    model,
    searchField,
    contractId
  ) {
    return this.executeFiles(
      "get",
      `/Report/activity/pdf?fromDate=${fromDate}&ownerType=${ownerType}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&model=${model}&accessCodes=${accesscontrolcode}&searchKey=${searchField}&contractId=${contractId}`
    );
  },
  getNewUtilizationReportListPDF(
    fromDate,
    toDate,
    machineIds,
    zone,
    groupIds,
    jobSite,
    model,
    searchField,
    contractId,
    sortBy,
    sortOrder,
    ownerType
  ) {
    return this.executeFiles(
      "get",
      `/Report/newutilization/pdf?ownerType=${ownerType}&fromDate=${fromDate}&toDate=${toDate}&machineIds=${machineIds}&zone=${zone}&groupIds=${groupIds}&jobSite=${jobSite}&model=${model}&searchKey=${searchField}&contractId=${contractId}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
  },

  // scheduled Reports apis
  createScheduledReport(payload) {
    return this.execute("post", `/ReportSchedule`, payload);
  },
  updateScheduledReport(scheduleid, payload) {
    return this.execute("put", `/ReportSchedule/${scheduleid}`, payload);
  },
  updateAlertsReport(alertid, payload) {
    return this.execute("put", `/ReportSchedule/${alertid}`, payload);
  },
  getScheduledReportList(CustomerId, reportId) {
    return this.execute(
      "get",
      `/ReportSchedule?CustomerId=${CustomerId}&reportId=${reportId}`
    );
  },
  getScheduledReports(pageNumber, pageSize) {
    return this.execute(
      "get",
      `/ReportSchedule/scheduled?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },
  deleteSchedule(reportId) {
    return this.execute("delete", `/ReportSchedule/${reportId}`);
  },
  deleteAlerts(reportId) {
    return this.execute("delete", `/ReportSchedule/${reportId}`);
  },
  getLinkWorkOrderIdData(workOrderId) {
    return this.execute(
      "get",
      `/ServiceTemplate/getlinkworkorderdetails?Id=${workOrderId}`
    );
  },
  updateLinkWorkorder(workOrderId, payload) {
    return this.execute(
      "put",
      `/ServiceTemplate/updatelinkworkorderdetails?Id=${workOrderId}`,
      payload
    );
  },
  downloadeservicetemplate(id) {
    return this.executeFiles("post", `/ServiceTemplate/download?fileId=${id}`);
  },
  deleteeservicetemplate(id) {
    return this.executeFiles("delete", `/ServiceTemplate/attachment/${id}`);
  },
  getAlarmsType() {
    return this.execute("get", `Alert/alerts`);
  },
  deleteAlert(id) {
    return this.execute("delete", `/Alert/alert/id?id=${id}`);
  },
  createAlarms(payload) {
    // return this.execute("post", "Alarm/alarm", payload);
    return this.execute("post", "Alert/alert", payload);
  },
  createAlarmLogistics(payload) {
    // return this.execute("post", "Alarm/alarm", payload);
    return this.execute("post", "Alert/logistic", payload);
  },
  getAlarmsById(id) {
    return this.execute("get", `/Alert/alertwithequipment/${id}`);
  },
  getAlarmBatteryContacts(custid) {
    return this.execute("get", `/Alert/contacts?customerId=${custid}`);
  },
  CreateAlarmBatteryContacts(custid, payload) {
    return this.execute("post", `/Alert/contact?customerId=${custid}`, payload);
  },
  deleteBatteryAlarm(id) {
    return this.execute("delete", `/Alarm/alarms/id?id=${id}`);
  },
  UpdateBatteryAlarm(id, payload) {
    return this.execute("put", `/Alarm/alarm/${id}`, payload);
  },
  UpdateOperationalAlerts(id, payload) {
    return this.execute("put", `/Alert/alert/${id}`, payload);
  },
  UpdateLogisticsAlerts(id, payload) {
    return this.execute("put", `/Alert/logisticAlert/${id}`, payload);
  },
  updateAlarmBatteryEnabled(id, payload) {
    return this.execute("put", `Alarm/alarm/${id}/disable-or-enable`, payload);
  },
  updateAlertEnabled(id, payload) {
    return this.execute("put", `Alert/alert/${id}/disable-or-enable`, payload);
  },
  updateCustomerOwnedDetails(payload) {
    return this.execute("put", `/Equipments/customerEquipment`, payload);
  },
  getUnitHistory(unitId, prevdate, date, contractId) {
    return this.execute(
      "get",
      `/Equipments/Tripdetails?unitId=${unitId}&fromDate=${prevdate}&toDate=${date}&contractId=${contractId}`
    );
  },
  getUnitHistoryNew(assetId, prevdate, date, contractId) {
    return this.execute(
      "get",
      `/Equipments/Tripdetails/assetId?assetId=${assetId}&fromDate=${prevdate}&toDate=${date}&contractId=${contractId}`
    );
  },
  getBrandsSearch(searchKey) {
    return this.execute(
      "get",
      `/Equipments/brands/search?searchKey=${searchKey}`
    );
  },
  getModelsSearch(searchKey) {
    return this.execute(
      "get",
      `/Equipments/models/search?searchKey=${searchKey}`
    );
  },
  getCategoriesSearch(searchKey) {
    return this.execute(
      "get",
      `/Equipments/categories/search?searchKey=${searchKey}`
    );
  },
  updateEnableDisableAccess(payload) {
    return this.execute("put", `Customers/enableaccesskeys`, payload);
  },
  saveAccessKeys(payload) {
    return this.execute("post", `Equipments/accesscode/create`, payload);
  },
  updateAccessKeys(id, payload) {
    return this.execute("put", `Equipments/accesscode/${id}`, payload);
  },
  getMasterKey(customerId) {
    return this.execute(
      "get",
      `Equipments/accesscodes/master?customerId=${customerId}`
    );
  },
  getAccessCodesByAssets(customerId, assetId) {
    return this.execute(
      "get",
      `Equipments/accesscodes/asset?customerId=${customerId}&assetId=${assetId}`
    );
  },
  getAccesscodesRefresh() {
    return this.execute("post", `Equipments/accesscodes/refresh`);
  },

  updateLockUnlockAccessCodes(assetId, isLocked) {
    return this.execute(
      "put",
      `Equipments/${assetId}/lock-unlock?isLocked=${isLocked}`
    );
  },
  getGroupControlOperatorsList() {
    return this.execute("get", `Operator/group`);
  },
  getOperatorsList() {
    return this.execute("get", `Operator`);
  },
  getOperatorgroupById(id) {
    return this.execute("get", `Operator/group/${id}`);
  },
  getOperatorById(id) {
    return this.execute("get", `Operator/${id}`);
  },
  creategroupOperator(payload) {
    return this.execute("post", `Operator/group`, payload);
  },
  updategroupOperator(id, payload) {
    return this.execute("put", `Operator/group/${id}`, payload);
  },
  createOperator(payload) {
    return this.execute("post", `Operator`, payload);
  },
  updateOperator(id, payload) {
    return this.execute("put", `Operator/${id}`, payload);
  },
  deleteGroupControl(id) {
    return this.execute("delete", `Operator/group/${id}`);
  },

  deleteOperatorControl(id) {
    return this.execute("delete", `Operator/${id}`);
  },

  getJobsitesAccessCodes() {
    return this.execute("get", `JobsiteAccessCode`);
  },

  updateJobsiteAccessCode(payload) {
    return this.execute("post", `JobsiteAccessCode`, payload);
  },

  deletejobsiteAccessCode(id) {
    return this.execute("delete", `JobsiteAccessCode/${id}`);
  },

  getFleetsInAlerts(
    searchtext,
    model,
    make,
    pageNo,
    pageSize,
    sortBy,
    sortOrder
  ) {
    // let tempsortOrder;
    // tempsortOrder = sortOrder == "asc" ? true : false;
    const query = buildQuery({
      searchKey: searchtext,
      model,
      brand: make,
      pageNo,
      pageSize,
      orderBy: sortBy,
      isAscending: sortOrder,
    });
    return this.execute("get", `Equipments/telematicassets?${query}`);
  },
  getTelematicAssetsByFleetIds(fleetIds) {
    const query = buildQuery({
      fleetIds: fleetIds.join(","),
      pageNo: 1,
      pageSize: -1,
    });
    return this.execute("get", `Equipments/telematicassets?${query}`);
  },
};
